export const EMPTY_ARRAY = [];
export const EMPTY_OBJ = Object.freeze({});

export const SORT_DIR_ASC = "asc";
export const SORT_DIR_DESC = "desc";

export const NULL_FILTER_VALUE = "=NULL";
export const NULL_DATETIME_PATTERN = /^0001-01-01T/g;

export const BOOL_VALUE_TRUE = "true";
export const BOOL_VALUE_FALSE = "false";
export const BOOL_VALUE_INDETERMINATE = "indeterminate";

export const FILTER_OP_EQ = "=";
export const FILTER_OP_LTE = "<=";
export const FILTER_OP_GTE = ">=";

export const A11Y_CONTENT_CURRENT_PAGE = "a11y-content-current-page";

export const DOMAIN_USER_MENU = "UserMenu";

export const PROCESS_TASK_TYPE_START = "StartProcess";
export const PROCESS_TASK_TYPE_EXECUTE = "ExecuteUserTask";

export const PROCESS_OPERATION_START = "Start";
export const PROCESS_OPERATION_EXECUTE = "Execute";
export const PROCESS_OPERATION_REJECT = "Reject";

export const PROCESS_STATE_WAITING = "Waiting";
export const PROCESS_STATE_CREATING = "Creating";
export const PROCESS_STATE_WORKING = "Working";
export const PROCESS_STATE_DONE = "Done";
export const PROCESS_STATE_ERROR = "Error";
export const PROCESS_STATE_HANGING = "Hanging";
export const PROCESS_STATE_CONTINUE = "Continue";
export const PROCESS_STATE_SKIPPED = "Skipped";

export const multiProcessStages = {
  IDLE: "Idle",
  LOADING: "Loading",
  EDITING: "Editing",
  EXECUTING: "Executing",
  CONTINUE: "Continue",
};
